/**
 * The Czech legal documents, as supplied by counsel.
 *
 * GENERATED by `scripts/generate-legal.mjs` from the Word files in `terms-to-use/`.
 * Do not edit: a wording change comes from counsel and is applied with `make legal`.
 */

import type { LegalDocument } from "./types";

export const CS_LEGAL_DOCUMENTS: LegalDocument[] = [
  {
    slug: "terms",
    title: "Podmínky používání aplikace Elyxeer 30.5",
    subtitle: "Pravidla přístupu předplatitelů k aplikaci a digitálnímu obsahu",
    sections: [
      {
        number: null,
        heading: null,
        blocks: [
          {
            kind: "paragraph",
            text: "Tyto podmínky upravují používání mobilní a webové aplikace Elyxeer 30.5. Aplikace je bez dalšího poplatku zpřístupněna oprávněným předplatitelům ELYXEER a slouží k přístupu k digitálnímu obsahu, komunikaci s týmem a správě předplatného. Používáním aplikace uživatel potvrzuje, že se s těmito podmínkami seznámil.",
          },
        ],
      },
      {
        number: "1",
        heading: "Provozovatel a působnost",
        blocks: [
          {
            kind: "paragraph",
            text: "1.1 Provozovatelem aplikace je AMPM Labs s.r.o., IČO 23552751, DIČ CZ23552751, se sídlem Dlouhá 730/35, Staré Město, 110 00 Praha 1, zapsaná v obchodním rejstříku vedeném Městským soudem v Praze, oddíl C, vložka 429068 (dále jen „provozovatel“). Kontaktní e-mail je info@elyxeer.com.",
          },
          {
            kind: "paragraph",
            text: "1.2 Aplikace je při svém spuštění zaměřena zejména na uživatele v České republice a na Slovensku, může však být zpřístupněna také uživatelům v dalších zemích. Tyto podmínky se použijí na všechny uživatele, kterým je aplikace oprávněně zpřístupněna, bez ohledu na zemi jejich pobytu. Právní vztahy týkající se nákupu a dodávek fyzických produktů se současně řídí obchodními podmínkami internetového obchodu ELYXEER platnými pro konkrétní objednávku.",
          },
          {
            kind: "paragraph",
            text: "1.3 Přístup je určen oprávněným předplatitelům a osobám, kterým provozovatel přístup individuálně udělil. Provozovatel za účelem přístupu do aplikace nevyžaduje datum narození.",
          },
          {
            kind: "paragraph",
            text: "1.4 Dostupnost aplikace, jednotlivých funkcí, předplatného, platebních možností, obsahu a jazykových verzí se může v jednotlivých zemích lišit. Provozovatel může zpřístupnění v určité zemi omezit, pokud to vyžadují právní, regulatorní, technické, platební nebo smluvní podmínky. Tím nejsou dotčena již vzniklá práva uživatelů.",
          },
        ],
      },
      {
        number: "2",
        heading: "Přístup k aplikaci a uživatelský účet",
        blocks: [
          {
            kind: "paragraph",
            text: "2.1 Přístup je vázán na e-mailovou adresu evidovanou u aktivního předplatného ELYXEER v systému Shopify. Účet může provozovatel založit automaticky nebo uživatele výjimečně pozvat ručně.",
          },
          {
            kind: "paragraph",
            text: "2.2 Licence a účet jsou osobní a nepřenosné. Uživatel nesmí sdílet přihlašovací údaje, umožnit přístup jiné osobě ani obcházet kontrolu oprávnění. Uživatel odpovídá za ochranu své e-mailové schránky a oznámí podezření na zneužití.",
          },
          {
            kind: "paragraph",
            text: "2.3 Přístup trvá po dobu aktivního předplatného nebo po dobu ručně uděleného oprávnění. Po zániku předplatného může provozovatel účet a přístup deaktivovat. Záznamy, které musí uchovat podle právních předpisů nebo pro ochranu práv, mohou zůstat uchovány po nezbytnou dobu.",
          },
          {
            kind: "paragraph",
            text: "2.4 Uživatel může prostřednictvím funkcí zpřístupněných v aplikaci spravovat své předplatné. Samotná aplikace neúčtuje samostatnou cenu za digitální obsah. Platební a smluvní změny se řídí e-shopovými podmínkami a informacemi zobrazenými před potvrzením změny.",
          },
        ],
      },
      {
        number: "3",
        heading: "Funkce aplikace",
        blocks: [
          { kind: "paragraph", text: "3.1 Aplikace nabízí zejména:" },
          {
            kind: "bullets",
            items: [
              "živá vysílání pro předplatitele s možností položit dotaz týmu nebo hostům;",
              "soukromé dotazy a odpovědi mezi uživatelem a správcem;",
              "články, podcasty, videa, protokoly a další vzdělávací obsah o zdravém životním stylu;",
              "filtrování a vyhledávání obsahu;",
              "zobrazení a správa údajů souvisejících s předplatným v rozsahu nabízeném aplikací.",
            ],
          },
          {
            kind: "paragraph",
            text: "3.2 Provozovatel může skladbu, pořadí a dostupnost obsahu průběžně měnit. Nezaručuje nepřetržitou dostupnost každé jednotlivé položky, konkrétního hosta ani konkrétní termín vysílání. Podstatné omezení celé služby oznámí přiměřeným způsobem.",
          },
        ],
      },
      {
        number: "4",
        heading: "Zdravotní a odborné upozornění",
        blocks: [
          {
            kind: "paragraph",
            text: "4.1 Provozovatel ani aplikace Elyxeer 30.5 nejsou zdravotnickým zařízením ani poskytovatelem zdravotních služeb. Neprovádíme diagnostiku ani sledování zdravotního stavu a neposkytujeme léčbu, individuální zdravotní prevenci, lékařská doporučení, léčebné plány ani zdravotní péči. Aplikace se zaměřuje výhradně na obecné informace a vzdělávání v oblasti suplementace a zdravého životního stylu.",
          },
          {
            kind: "paragraph",
            text: "4.2 Uživatel nemá na základě obsahu zahajovat, měnit ani ukončovat léčbu nebo užívání léčiv. Před rozhodnutím, které může ovlivnit zdraví, má zohlednit svůj zdravotní stav a poradit se s odborníkem. Při akutních nebo závažných obtížích má bezodkladně vyhledat příslušnou zdravotní pomoc.",
          },
          {
            kind: "paragraph",
            text: "4.3 Odpovědi týmu na dotazy jsou obecné a vycházejí pouze z informací, které uživatel sdělil. Uživatel nemá do chatu zasílat zdravotnickou dokumentaci, rodná čísla, čísla dokladů, platební údaje ani jiné údaje, které nejsou pro dotaz nezbytné.",
          },
        ],
      },
      {
        number: "5",
        heading: "Soukromé dotazy a pravidla komunikace",
        blocks: [
          {
            kind: "paragraph",
            text: "5.1 Dotaz a odpověď jsou zpřístupněny uživateli a oprávněným členům týmu nebo dodavatelům provozovatele. Ostatní předplatitelé je nevidí. Provozovatel negarantuje okamžitou odpověď ani řešení naléhavých situací.",
          },
          {
            kind: "paragraph",
            text: "5.2 Uživatel nesmí zasílat protiprávní, výhrůžný, urážlivý, diskriminační, sexuálně explicitní, podvodný nebo škodlivý obsah; zasahovat do práv třetích osob; vydávat se za jinou osobu; šířit malware, spam nebo reklamu; ani službu používat k obtěžování.",
          },
          {
            kind: "paragraph",
            text: "5.3 Provozovatel může závadný obsah odstranit, omezit komunikaci, zablokovat účet a v závažných případech věc oznámit příslušným orgánům. Uživatel může problém nahlásit na e-mailu provozovatele. Podněty budou posouzeny bez zbytečného odkladu.",
          },
        ],
      },
      {
        number: "6",
        heading: "Živá vysílání",
        blocks: [
          {
            kind: "paragraph",
            text: "6.1 Uživatel respektuje pokyny moderátora a práva ostatních účastníků. Provozovatel může dotaz nezveřejnit, zkrátit nebo upravit tak, aby odstranil osobní údaje či nevhodný obsah, aniž změní jeho podstatu.",
          },
          {
            kind: "paragraph",
            text: "6.2 Uživatel nesmí vysílání nahrávat, přenášet, veřejně sdělovat ani zpřístupnit jiné osobě. Pokud bude konkrétní vysílání provozovatelem nahráváno, budou účastníci předem informováni o rozsahu záznamu a jeho použití.",
          },
        ],
      },
      {
        number: "7",
        heading: "Duševní vlastnictví a licence",
        blocks: [
          {
            kind: "paragraph",
            text: "7.1 Texty, grafika, videa, zvukové záznamy, protokoly, databázové uspořádání, označení a ostatní obsah jsou chráněny právními předpisy. Práva náleží provozovateli nebo jeho licenčním partnerům.",
          },
          {
            kind: "paragraph",
            text: "7.2 Uživatel získává omezené, nevýhradní, nepřenosné a odvolatelné oprávnění používat obsah pro vlastní nekomerční potřebu po dobu oprávněného přístupu. Pokud aplikace výslovně nenabízí povolené offline uložení, uživatel nesmí obsah stahovat.",
          },
          {
            kind: "paragraph",
            text: "7.3 Bez předchozího písemného souhlasu je zakázáno obsah kopírovat, fotografovat nebo nahrávat za účelem dalšího šíření, zveřejňovat, prodávat, poskytovat třetím osobám, systematicky vytěžovat, automatizovaně získávat, upravovat, vytvářet z něj databáze nebo učební data ani obcházet technická omezení. Tím nejsou dotčena oprávnění, která nelze smluvně vyloučit.",
          },
        ],
      },
      {
        number: "8",
        heading: "Provoz a odpovědnost",
        blocks: [
          {
            kind: "paragraph",
            text: "8.1 Provozovatel může provádět údržbu, bezpečnostní zásahy a aktualizace. O plánovaném delším omezení bude uživatele podle možností informovat. Uživatel používá podporované zařízení, aktuální systém a bezpečné připojení.",
          },
          {
            kind: "paragraph",
            text: "8.2 Provozovatel odpovídá za újmu v rozsahu stanoveném kogentními právními předpisy. Nic v těchto podmínkách nevylučuje zákonná práva spotřebitele, odpovědnost za úmysl nebo hrubou nedbalost ani odpovědnost, kterou nelze platně omezit.",
          },
          {
            kind: "paragraph",
            text: "8.3 Provozovatel poskytuje aktualizace, včetně bezpečnostních aktualizací, které jsou nezbytné k řádnému a bezpečnému používání aplikace. Uživatel má aktualizace instalovat v přiměřené době; provozovatel neodpovídá za vadu způsobenou výlučně neprovedením řádně oznámené aktualizace, pokud uživatele informoval o její dostupnosti a následcích neprovedení.",
          },
          {
            kind: "paragraph",
            text: "8.4 Uživatel oznámí technickou vadu na kontaktní e-mail a popíše zařízení, verzi aplikace a problém. Má právo zejména požadovat odstranění vady; další práva z vadného poskytnutí digitální služby se řídí kogentními právními předpisy a zůstávají zachována.",
          },
        ],
      },
      {
        number: "9",
        heading: "Pozastavení a ukončení přístupu",
        blocks: [
          {
            kind: "paragraph",
            text: "9.1 Provozovatel může přístup přiměřeně pozastavit zejména při zániku oprávnění, ohrožení bezpečnosti, sdílení účtu, zneužití služby nebo závažném porušení těchto podmínek. Je-li to vzhledem k okolnostem možné, uživatele předem upozorní a umožní nápravu.",
          },
          {
            kind: "paragraph",
            text: "9.2 Zrušení předplatného se provádí způsobem uvedeným v e-shopových podmínkách nebo prostřednictvím dostupné správy předplatného. Následkem je ukončení budoucích dodávek a po skončení oprávněného období také přístupu do aplikace.",
          },
          {
            kind: "paragraph",
            text: "9.3 Žádost týkající se účtu nebo osobních údajů lze podat v aplikaci, je-li příslušná funkce dostupná, nebo na kontaktním e-mailu. Podrobnosti obsahují Zásady ochrany osobních údajů a Pokyny ke zrušení účtu a výmazu dat.",
          },
        ],
      },
      {
        number: "10",
        heading: "Stížnosti a řešení sporů",
        blocks: [
          {
            kind: "paragraph",
            text: "10.1 Uživatel může stížnost zaslat na kontaktní e-mail. Spotřebitelský spor lze řešit také mimosoudně u České obchodní inspekce, www.coi.cz. Tím nejsou dotčeny prostředky ochrany, které spotřebiteli poskytuje stát jeho obvyklého bydliště.",
          },
        ],
      },
      {
        number: "11",
        heading: "Závěrečná ustanovení",
        blocks: [
          {
            kind: "paragraph",
            text: "11.1 Právní vztahy se řídí právem České republiky. Spotřebitel tím není zbaven ochrany kogentních ustanovení práva státu svého obvyklého bydliště.",
          },
          {
            kind: "paragraph",
            text: "11.2 Provozovatel může podmínky nebo digitální službu přiměřeně změnit zejména kvůli změně právních předpisů, funkcí, technologií nebo zabezpečení. Změna nebude provedena bez spravedlivého důvodu ani uživateli nezpůsobí dodatečné náklady. O změně, která není jen drobná a může negativně ovlivnit přístup nebo používání, informuje uživatele předem jasným způsobem a poučí jej o zákonných právech. Změna se nedotkne již vzniklých práv.",
          },
          {
            kind: "paragraph",
            text: "11.3 Tyto podmínky nabývají účinnosti dne 20. září 2026.",
          },
        ],
      },
    ],
  },
  {
    slug: "privacy",
    title: "Zásady ochrany osobních údajů Elyxeer 30.5",
    subtitle: "Informace pro uživatele mobilní a webové aplikace",
    sections: [
      {
        number: null,
        heading: null,
        blocks: [
          {
            kind: "paragraph",
            text: "Tyto zásady vysvětlují, jaké osobní údaje zpracováváme při zpřístupnění a používání aplikace Elyxeer 30.5, proč je zpracováváme, jak dlouho je uchováváme a jaká práva mají uživatelé.",
          },
        ],
      },
      {
        number: "1",
        heading: "Správce a kontakt",
        blocks: [
          {
            kind: "paragraph",
            text: "Správcem osobních údajů je AMPM Labs s.r.o., IČO 23552751, DIČ CZ23552751, se sídlem Dlouhá 730/35, Staré Město, 110 00 Praha 1, zapsaná v obchodním rejstříku vedeném Městským soudem v Praze, oddíl C, vložka 429068. Ve věcech ochrany osobních údajů nás kontaktujte na info@elyxeer.com.",
          },
        ],
      },
      {
        number: "2",
        heading: "Rozsah zpracování",
        blocks: [
          {
            kind: "table",
            columns: [
              "Účel",
              "Údaje",
              "Právní základ",
              "Základní doba uchování",
            ],
            rows: [
              [
                "Založení a vedení účtu",
                "e-mail, interní identifikátor, stav oprávnění, čas přihlášení; datum narození nevyžadujeme",
                "plnění smlouvy",
                "po dobu aktivního účtu; poté zpravidla 3 roky pro ochranu práv",
              ],
              [
                "Ověření předplatného a jeho správa",
                "e-mail, identifikátor zákazníka a předplatného, stav, nezbytné údaje o objednávce a správě",
                "plnění smlouvy; právní povinnost u účetních záznamů",
                "podle e-shopových podmínek a zákonných archivačních lhůt",
              ],
              [
                "Poskytování obsahu",
                "historie přístupu, zvolené filtry a technické údaje o přehrávání",
                "plnění smlouvy",
                "po dobu účtu; agregované údaje mohou zůstat anonymní",
              ],
              [
                "Soukromý chat a podpora",
                "text dotazu a odpovědi, e-mail, čas komunikace, případné přílohy",
                "plnění smlouvy; oprávněný zájem na podpoře a ochraně práv",
                "po dobu vyřízení a následně zpravidla nejvýše 3 roky, není-li potřebná delší zákonná ochrana",
              ],
              [
                "Živá vysílání",
                "přihlášení, dotaz, jméno či označení zvolené uživatelem, technické údaje přenosu",
                "plnění smlouvy",
                "po dobu potřebnou k uskutečnění vysílání; záznam jen podle předchozí informace",
              ],
              [
                "Bezpečnost a provoz",
                "IP adresa, zařízení, verze aplikace, systémové a bezpečnostní logy, chybová hlášení",
                "oprávněný zájem na bezpečném provozu",
                "zpravidla nejvýše 6 měsíců, déle při řešení incidentu",
              ],
              [
                "Analytika používání",
                "události v aplikaci, navštívené sekce, délka relace, přibližné technické údaje zařízení",
                "souhlas, pokud nejde o nezbytnou provozní analytiku",
                "podle nastavení analytického nástroje, nejdéle 14 měsíců",
              ],
              [
                "Právní nároky a compliance",
                "relevantní účetní, smluvní a komunikační záznamy",
                "právní povinnost; oprávněný zájem",
                "po dobu zákonné povinnosti nebo promlčecí lhůty",
              ],
            ],
          },
        ],
      },
      {
        number: "3",
        heading: "Propojení se Shopify",
        blocks: [
          {
            kind: "paragraph",
            text: "Aplikace je automatizovaně propojena s e-shopovým účtem v Shopify. Z e-shopového prostředí získává zejména e-mail, identifikátor zákazníka a informaci, zda je předplatné aktivní. V rozsahu, v němž uživatel v aplikaci spravuje předplatné, se mohou zobrazovat nebo předávat další údaje nezbytné k provedení požadované změny. Platební údaje zpracovává příslušný poskytovatel platebních služeb; v aplikaci nemáme ukládat úplné údaje platební karty.",
          },
        ],
      },
      {
        number: "4",
        heading: "Zdravotní a jiné citlivé údaje",
        blocks: [
          {
            kind: "paragraph",
            text: "Provozovatel ani aplikace nejsou zdravotnickým zařízením ani poskytovatelem zdravotních služeb. Aplikace se věnuje obecným informacím o suplementaci a zdravém životním stylu; není určena k diagnostice, léčbě ani sledování zdravotního stavu. Není určena ani ke shromažďování údajů z Apple Health, Google Health Connect, nositelné elektroniky či zdravotnických zařízení. Uživatel může ve volném textu dotazu dobrovolně uvést informace o zdraví. Žádáme uživatele, aby uváděl jen údaje nezbytné pro formulaci obecného dotazu a nezasílal zdravotnickou dokumentaci ani identifikátory, které nejsou potřebné.",
          },
          {
            kind: "paragraph",
            text: "Pokud chce uživatel do dotazu uvést údaj o zdravotním stavu, aplikace před odesláním vyžádá jeho samostatný výslovný souhlas podle čl. 9 odst. 2 písm. a) GDPR. Údaj zpracujeme pouze v rozsahu nezbytném k vyřízení dotazu a s odpovídající ochranou. Souhlas lze kdykoli odvolat; odvolání neovlivní zákonnost dřívějšího zpracování. Bez udělení souhlasu uživatel zdravotní údaje do dotazu uvádět nesmí.",
          },
        ],
      },
      {
        number: "5",
        heading: "Analytika a technologie v zařízení",
        blocks: [
          {
            kind: "paragraph",
            text: "Sledujeme používání aplikace za účelem zjištění, které části jsou využívány a kde vznikají technické problémy. Nezbytné technické záznamy používáme k provozu a zabezpečení. Analytické ukládání nebo čtení údajů v zařízení, které není nezbytné, aktivujeme až po souhlasu uživatele. Souhlas lze odmítnout nebo později odvolat v nastavení soukromí, aniž je tím dotčen základní přístup k aplikaci.",
          },
          {
            kind: "paragraph",
            text: "Nepoužíváme osobní údaje z aplikace pro behaviorální reklamu ani pro sledování uživatele napříč aplikacemi třetích osob, pokud o takovém novém účelu uživatele předem jasně neinformujeme a nezískáme potřebný souhlas.",
          },
        ],
      },
      {
        number: "6",
        heading: "Příjemci a dodavatelé",
        blocks: [
          {
            kind: "bullets",
            items: [
              "Shopify a související poskytovatelé e-shopu a správy předplatného;",
              "poskytovatelé hostingu, databází, zabezpečení, technické podpory a vývoje;",
              "poskytovatelé videopřenosu, chatu, e-mailů a push notifikací podle skutečně použitých funkcí;",
              "poskytovatel analytiky a hlášení technických chyb;",
              "právní, účetní a další odborní poradci a orgány veřejné moci, stanoví-li to zákon.",
            ],
          },
          {
            kind: "paragraph",
            text: "Dodavatelé zpracovávají údaje pouze podle smlouvy a našich pokynů, pokud sami neurčují účely zpracování jako samostatní správci. Aktuální informace o konkrétních významných dodavatelích poskytujeme na vyžádání a v nastavení soukromí aplikace, je-li to relevantní.",
          },
        ],
      },
      {
        number: "7",
        heading: "Předávání mimo Evropský hospodářský prostor",
        blocks: [
          {
            kind: "paragraph",
            text: "Někteří technologičtí dodavatelé mohou zpracovávat údaje mimo Evropský hospodářský prostor. Předání se uskuteční pouze na základě rozhodnutí Evropské komise o odpovídající ochraně nebo vhodných záruk, zejména standardních smluvních doložek, a podle potřeby doplňkových opatření. Informaci o použitém mechanismu lze získat na kontaktním e-mailu.",
          },
        ],
      },
      {
        number: "8",
        heading: "Automatizované rozhodování",
        blocks: [
          {
            kind: "paragraph",
            text: "Oprávnění k přístupu se může automaticky aktivovat nebo deaktivovat podle stavu předplatného. Jde o technické provedení smlouvy. Neprovádíme jiné rozhodování založené výlučně na automatizovaném zpracování, které by mělo pro uživatele právní nebo obdobně významné účinky.",
          },
        ],
      },
      {
        number: "9",
        heading: "Práva uživatele",
        blocks: [
          {
            kind: "bullets",
            items: [
              "právo na přístup k osobním údajům a jejich kopii;",
              "právo na opravu nepřesných nebo neúplných údajů;",
              "právo na výmaz a omezení zpracování, jsou-li splněny zákonné podmínky;",
              "právo na přenositelnost údajů zpracovávaných automatizovaně na základě souhlasu nebo smlouvy;",
              "právo vznést námitku proti zpracování založenému na oprávněném zájmu;",
              "právo kdykoli odvolat souhlas bez dopadu na dřívější zákonnost zpracování;",
              "právo podat stížnost u dozorového úřadu pro ochranu osobních údajů, zejména v zemi obvyklého bydliště, místa výkonu práce nebo místa údajného porušení. V České republice je tímto úřadem Úřad pro ochranu osobních údajů a na Slovensku Úrad na ochranu osobných údajov Slovenskej republiky.",
            ],
          },
          {
            kind: "paragraph",
            text: "Žádost lze uplatnit na info@elyxeer.com. Můžeme přiměřeně ověřit totožnost žadatele. O žádosti rozhodneme bez zbytečného odkladu, zpravidla do jednoho měsíce.",
          },
        ],
      },
      {
        number: "10",
        heading: "Výmaz účtu",
        blocks: [
          {
            kind: "paragraph",
            text: "Uživatel může zahájit žádost o výmaz účtu prostřednictvím funkce v aplikaci nebo kontaktního e-mailu. Výmaz aplikačního účtu a zrušení obchodního předplatného jsou odlišné úkony, pokud rozhraní výslovně nepotvrdí jejich společné provedení. Před potvrzením uživatele informujeme o důsledcích. Údaje, které musíme uchovat kvůli právní povinnosti, bezpečnosti nebo právním nárokům, nevymažeme dříve, než tento důvod pomine.",
          },
        ],
      },
      {
        number: "11",
        heading: "Zabezpečení a změny zásad",
        blocks: [
          {
            kind: "paragraph",
            text: "Používáme přiměřená technická a organizační opatření, zejména řízení přístupů, zabezpečený přenos, evidenci oprávnění, zálohování a postupy pro řešení incidentů. Žádný systém však nelze prohlásit za absolutně bezpečný.",
          },
          {
            kind: "paragraph",
            text: "Zásady můžeme aktualizovat při změně funkcí, dodavatelů nebo právních povinností. O podstatné změně informujeme v aplikaci nebo e-mailem před její účinností, je-li to přiměřené. Aktuální znění bude trvale dostupné bez nutnosti přihlášení.",
          },
          {
            kind: "paragraph",
            text: "Tyto zásady jsou účinné od 20. září 2026.",
          },
        ],
      },
    ],
  },
  {
    slug: "account-deletion",
    title: "Zrušení účtu a výmaz dat Elyxeer 30.5",
    subtitle: "Veřejné pokyny pro uživatele aplikace",
    sections: [
      {
        number: null,
        heading: null,
        blocks: [
          {
            kind: "paragraph",
            text: "Uživatel může požádat o odstranění účtu Elyxeer 30.5 a osobních údajů, které již nejsou potřebné. Tato stránka má být veřejně dostupná bez přihlášení a její odkaz má být uveden v Google Play Console i v aplikaci.",
          },
        ],
      },
      {
        number: null,
        heading: "Jak žádost podat",
        blocks: [
          {
            kind: "steps",
            items: [
              "V aplikaci otevřete Nastavení, zvolte Účet a poté Zrušit účet a vymazat data.",
              "Pokud se do aplikace nemůžete přihlásit, napište z e-mailové adresy spojené s účtem na info@elyxeer.com a do předmětu uveďte „Výmaz účtu Elyxeer 30.5“.",
              "Potvrďte žádost způsobem, který vám zašleme. Můžeme vyžádat přiměřené ověření totožnosti, abychom zabránili zneužití.",
              "Před konečným potvrzením se zobrazí důsledky pro přístup do aplikace a samostatně stav předplatného ELYXEER.",
            ],
          },
        ],
      },
      {
        number: null,
        heading: "Co bude odstraněno",
        blocks: [
          {
            kind: "bullets",
            items: [
              "aplikační profil a oprávnění k přístupu;",
              "historie používání přiřaditelná k účtu, pokud ji již nepotřebujeme;",
              "soukromé dotazy a další obsah účtu, pokud neexistuje důvod pro jejich další uchování;",
              "tokeny zařízení a nastavení aplikace uložená na serveru.",
            ],
          },
        ],
      },
      {
        number: null,
        heading: "Co může zůstat uchováno",
        blocks: [
          {
            kind: "paragraph",
            text: "Účetní a objednávkové doklady, doklady o platbách, záznamy potřebné k vyřízení reklamací, prevenci podvodů, bezpečnosti nebo ochraně práv uchováme jen po dobu vyžadovanou právními předpisy nebo nezbytnou pro daný účel. Tyto údaje již nepoužijeme pro běžné fungování odstraněného účtu.",
          },
        ],
      },
      {
        number: null,
        heading: "Vztah k předplatnému",
        blocks: [
          {
            kind: "paragraph",
            text: "Výmaz aplikačního účtu a zrušení předplatného jsou dva rozdílné kroky. Samotný výmaz účtu nesmí být považován za zrušení budoucích plateb nebo dodávek, pokud uživatel současně výslovně nepotvrdí zrušení předplatného. Při zrušení předplatného skončí přístup do aplikace po uplynutí příslušného oprávněného období.",
          },
        ],
      },
      {
        number: null,
        heading: "Lhůta a kontakt",
        blocks: [
          {
            kind: "paragraph",
            text: "Žádost vyřídíme bez zbytečného odkladu, zpravidla do jednoho měsíce. O dokončení nebo důvodu omezeného uchování vás informujeme. Kontakt: info@elyxeer.com.",
          },
        ],
      },
    ],
  },
];
